import React, { FC } from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../context/ApiContextProvider';
import { useURLContractId } from '../../layouts/ContractIdLayout/ContractIdLayout';
import { useMerchantCabinetConfig } from '../../config/ConfigProvider';

type DownloadPDFButtonProps = {
  transactionId: number;
  filename: string;
  namespace?: 'payments' | 'fasterPayments' | 'fasterPayouts';
  apiMethod: 'downloadPaymentPDF' | 'downloadFasterPaymentPDF' | 'downloadFasterPayoutPDF';
} & ButtonProps;

export const DownloadPDFButton: FC<DownloadPDFButtonProps> = ({
  transactionId,
  filename,
  namespace = 'payments',
  apiMethod,
  ...rest
}) => {
  const { t } = useTranslation([namespace]);
  const api = useApi();
  const contractId = useURLContractId();
  const { culture } = useMerchantCabinetConfig();

  const handleDownloadButtonClick = async () => {
    if (apiMethod === 'downloadFasterPaymentPDF') {
      await api.downloadFasterPaymentPDF(transactionId, filename, contractId, culture);
    } else if (apiMethod === 'downloadFasterPayoutPDF') {
      await api.downloadFasterPayoutPDF(transactionId, filename, contractId, culture);
    } else if (apiMethod === 'downloadPaymentPDF') {
      await api.downloadPaymentPDF(transactionId, filename, culture);
    }
  };

  return (
    <Button type="button" onClick={handleDownloadButtonClick} {...rest}>
      {t('downloadPDF', { ns: namespace })}
    </Button>
  );
};

export default DownloadPDFButton;
